export default "__VITE_ASSET__DriJCVtZ__"